import {useCallback} from 'react';
import {useReservation} from 'context/reservation';
import {environments} from 'configs';
import {ORIGINS} from '@chekin/core';
import {useTaxes} from './taxes';
import {useGuestGroup} from './useGuestGroup';
import ChekinProSettings from 'ChekinProSettings';

function useReservationSettings() {
  const {seasonEntity} = useTaxes();
  const {allowEditingGuestNumber, data: reservation} = useReservation();
  const {areAllGuestsRegistered} = useGuestGroup();
  const hasReservationNumber = Boolean(reservation?.booking_reference);

  const showReservationNumberBox =
    reservation &&
    [ORIGINS.guesty, ORIGINS.guesty2].includes(reservation.origin) &&
    hasReservationNumber;

  const checkCanEditReservationDetails = useCallback(() => {
    const isSDKMode = environments.VITE_APP_IS_SDK;
    const thereAreTaxRules = Boolean(seasonEntity?.rules && seasonEntity.rules.length);

    if (thereAreTaxRules) {
      return true;
    }

    if (!isSDKMode || ChekinProSettings.canEditReservationDetails === undefined) {
      return allowEditingGuestNumber;
    }

    return ChekinProSettings.canEditReservationDetails;
  }, [allowEditingGuestNumber, seasonEntity]);

  const checkCanShowRegisterButton = useCallback(() => {
    const isSDKMode = environments.VITE_APP_IS_SDK;

    if (isSDKMode) {
      return ChekinProSettings?.canEditReservationDetails || !areAllGuestsRegistered;
    }

    return allowEditingGuestNumber || !areAllGuestsRegistered;
  }, [areAllGuestsRegistered, allowEditingGuestNumber]);

  return {
    checkCanEditReservationDetails,
    checkCanShowRegisterButton,
    showReservationNumberBox,
  };
}

export {useReservationSettings};
